import { 
    Box, 
    Container, 
    createTheme, 
    MuiThemeProvider, 
    Typography, 
    IconButton,
    Button } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import {
    Cancel as CancelIcon, 
    Save as SaveIcon, 
    Add as AddIcon, 
    Delete as DeleteIcon, 
    Edit as EditIcon    
} from '@material-ui/icons';
import MUIDataTable from 'mui-datatables';
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import Select from '../../components/Form/Select';
import TextField from '../../components/Form/TextField';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import { useAuth } from '../../hooks/auth';
import ShedApi from '../../services/ShedApi';
import { useStyles } from './Style';
import PageTitle from '../../components/ui/PageTitleUI'
import MovementTypeApi from '../../services/MovementTypeApi';
import { MovementType } from '../../interfaces/MovementType';

type Props = {
    shedId: number,
    clickHandlerCalbkack?: () => void,
    clickHandlerClose?: () => void,
    handleSetSuccess?: (value: boolean) => void,
}

type editingMovementType = {
    movementTypeId?: string,
    tolerance?: string
}

const ShedForm: React.FC<Props> = (props) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [isLoadType, setIsLoadType] = useState(true);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t: tGeneral } = useTranslation("General");
    const { t : tShed } = useTranslation("Shed");
    const { t: tval } = useTranslation("Validation");
    const { enqueueSnackbar } = useSnackbar();
    const { user, isPortoReal } = useAuth();
    const [movementTypeList, setMovementTypeList] = useState<any>([]);
    const [shedMovementTypeList, setShedMovementTypeList] = useState<any[]>([]);
    const [companyList, setCompanyList] = useState<any>([]);
    const [editingMovementType, setEditingMovementType] = useState<editingMovementType>({movementTypeId: undefined, tolerance: undefined})
    const [shedsErrorMessage, setShedsErrorMessage] = useState<string>("")
    const refFieldMovementType = useRef<HTMLElement>(null)

    //Campos do Form
    interface IFormPanel {
        code: any;
        type: any;
        movementType: any;
        companies: any;
        tolerance: any;
        shedMovementTypeTolerance: any;
        generatesBtpInvoice: boolean;
    }

    //Metodos do form:
    const { handleSubmit, reset, control, register, setError, getValues, setValue, clearErrors } = useForm<IFormPanel>({
        defaultValues: {
            code: "",
            type: {},
            movementType: { code: '', label: ''},
            companies: [],
            shedMovementTypeTolerance: '',
            tolerance: '',
            generatesBtpInvoice: true
        }
    });

    const shedTypeList = [{code: '', label: ''}, {code: 'C', label: tShed('type_C')}, {code: 'D', label: tShed('type_D')}];
    
    const completeCompanyList = [
        { code: '154', plantId: 1, companyCode: 1,   label: 'Fiat Automoveis S.A.', uf: 'MG' },
        { code: '162', plantId: 0, companyCode: 162, label: 'Fiat Cordoba - 162 - Almacén 03', uf: '03' },
        { code: '165', plantId: 0, companyCode: 165, label: 'Fiat Cordoba - 165 - Almacén 03', uf: '03' },
        { code: '167', plantId: 3, companyCode: 191, label: 'JEEP Pernambuco', uf: 'PE' },
        { code: '168', plantId: 1, companyCode: 10,  label: 'FPT Fire - 010', uf: 'MG' },
        { code: '169', plantId: 1, companyCode: 12,  label: 'FPT Mecânica - 012', uf: 'MG' },
        { code: '170', plantId: 2, companyCode: 595, label: 'FPT Campo Largo - 595', uf: 'PR' },
        { code: '178', plantId: 0, companyCode: 1,   label: 'Fiat Filial CKD - 29', uf: 'MG' },
        { code: '179', plantId: 0, companyCode: 25,  label: 'Fiat Filial CKD - 33', uf: 'MG' },
        { code: '182', plantId: 5, companyCode: 1,   label: 'Fiat Matriz CKD - 31', uf: 'MG' },
        { code: '241', plantId: 4, companyCode: 3,   label: 'Mopar - P&A', uf: 'MG' },
        { code: '243', plantId: 6, companyCode: 630,   label: 'Porto Real', uf: 'RJ' }
    ];

    const yupValidationSaveForm = async (data: any) => {

        try {
            const schema = Yup.object().shape({
                type: Yup.object().nullable().required(tval("requiredField"))
                    .shape({code: Yup.string().required(tval("requiredField"))}),
                code: Yup.string()
                    .max(6, tval("maxLength6"))
                    .required(tval("requiredField")),
                companies: Yup.array().nullable().required(tval("requiredField"))
                    .test("suppliers", tval("requiredField"), (value) => {
                        
                        if (data.type && data.type.code && data.type.code === 'D'){
                            return true
                        }
                            

                        return  (value as unknown as 'any[] | null | undefined').length > 0
                    }),
                
            });

            

            await schema.validate(data, {
                abortEarly: false,
            });

            

        } catch (err) {
            
            var errors: any[] = []

            if (err instanceof Yup.ValidationError) {
               err.inner.forEach(error => {

                if (errors.filter(element => element.error.includes(error.message)).length === 0)
                    errors.push( {prop: error.path?.split('.')[0], error: error.message})

                setError(error.path?.split('.')[0] as
                    "code" | "type" | "companies"
                    , { message: error.message })
                })

                errors.forEach(element => { 
                    if (element.error === tval("requiredField"))
                        enqueueSnackbar(tGeneral("requiredFieldsValidation"), { variant: 'warning' }) 
                    else    
                        enqueueSnackbar(tval("theField") + tShed(element.prop) + " " + element.error, { variant: 'warning' }) 
                })
            }
 
            return false;
        }

        return true;
    }

    const onSubmit = async (data: any) => {

        if(!(await yupValidationSaveForm(data)))
            return;

        setShedsErrorMessage('')
        if (!shedMovementTypeList || shedMovementTypeList.length === 0) {
            setShedsErrorMessage(tShed('movementTypeRequired'))
            return
        }
            
        //Setar valores vindos dos campos <Select>:
        data.plantId = user.company.plantID;
        data.generatesBtpInvoice = isPortoReal() ? data.generatesBtpInvoice : true;
        data.type = data.type.code;
        if (data.companies)
            data.companies.forEach((item:any) => {
                item.companyId = item.code;
                item.companyName = item.label;
                item.companyUf = item.uf;
            });
            
        data.movementTypes = shedMovementTypeList
        
        setOpenBackdrop(true);
        if (props.shedId && props.shedId > 0) {

            // let put:ShedPost = data;
            // put.id = props.shedId;
            // put.updatedBy = user.userName;
            data.id = props.shedId;

            ShedApi.update(data)
                .then(result => {
                    enqueueSnackbar(tGeneral("returnSubmitEditFormSuccess"), { variant: 'success' });
                    if (props && props.handleSetSuccess)
                        props.handleSetSuccess(true);
                    if (props && props.clickHandlerCalbkack)
                        props.clickHandlerCalbkack()
                }).finally(() => {
                    setOpenBackdrop(false);
                });
        }
        else {

            ShedApi.create(data)
                .then(result => {
                    enqueueSnackbar(tGeneral("returnSubmitFormSuccess"), { variant: 'success' });
                    if (props && props.handleSetSuccess)
                        props.handleSetSuccess(true);
                    if (props && props.clickHandlerCalbkack)
                        props.clickHandlerCalbkack()
                }).finally(() => {
                    setOpenBackdrop(false);
                });
        }
    }

    const onChangeSelectType = async (data: any) => {
        if(data.code === 'C') 
            setIsLoadType(true);
        else
            setIsLoadType(false);
    }

    const getModel = useCallback(
        (shedId: number) => {
            if (props.shedId && props.shedId > 0) {
                setLoading(true);
                ShedApi.get(shedId).then((result) => {
                    if (result) {
                        //Preparar dados para os campos <select>
                        result.companies.forEach((item: any) => {
                            item.code = item.companyId;
                            item.label = item.companyName;
                            item.uf = item.companyUF
                        });
                        
                        result.movementTypes.forEach((element: any) => {
                            element.movementTypeDescription = element.movementType.description
                            element.tolerance = element.tolerance.slice(0, 5)
                        })

                        setShedMovementTypeList(result.movementTypes)

                        reset({
                            type: {code: result.type, label: tShed('type_' + result.type)},
                            code: result.code,
                            companies: result.companies,
                            generatesBtpInvoice: result.generatesBtpInvoice ?? true
                        });

                        if (result.type === 'D') setIsLoadType(false);
                    }
                }).finally(() => {
                    setLoading(false);
                });
            }
            else {
                reset({
                    type: {},
                    code: "",
                    companies: [],
                    generatesBtpInvoice: true
                });
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [props]
    );

    useEffect(() => {
        //Evitar pesquisas desnecessarias ao fechar o form:
        if (props.shedId < 0)
            return;
        
        var params: MovementType = {
            pageSize: 1000,
            plantId: Number(user.company.plantID),
            description: ""
        };

        MovementTypeApi.searchMovementType(params).then((result) => {
            if (result && result.items)
                setMovementTypeList(result.items.map((item: any) => { 
                    return { code: item.id, label: item.description } 
                }));
        });

        setCompanyList(completeCompanyList.filter((item: any) => item.plantId === user.company.plantID));

        setLoading(false);
        getModel(props.shedId);

        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, getModel])

    const handleIncludeMovementType = () => {
        var data = getValues()

        var validForm = true

        clearErrors('movementType')
        clearErrors('tolerance')
        setShedsErrorMessage('')

        if (!data.movementType || !data.movementType.code){
            setError('movementType', { message: tval("requiredField") });
            validForm = false
        }
        if (!data.tolerance || data.tolerance.replace('_', '').length < 5){
            setError('tolerance', { message: tval("formatTime") });
            validForm = false
        }

        if (parseInt(data.tolerance.split(':')[0]) < 0 ||
            parseInt(data.tolerance.split(':')[0]) > 23 || 
            parseInt(data.tolerance.split(':')[1]) < 0 ||
            parseInt(data.tolerance.split(':')[1]) > 59){
            setError('tolerance', { message: tval("formatTime24h") });
            validForm = false
        }

        if (validForm && 
            shedMovementTypeList.some((element : any) => element.movementTypeId.toString() === data.movementType.code.toString())) {
            enqueueSnackbar( tShed('itemAlreadyOnList'), { variant: 'warning' }) 
            validForm = false
        }

        if (!validForm)
            return

        setValue('tolerance', '') 

        var newShedMovementType = {
            movementTypeId: data.movementType.code,
            movementTypeDescription: data.movementType.label,
            shedId: props.shedId,
            tolerance: data.tolerance
        }

        setShedMovementTypeList([...shedMovementTypeList, newShedMovementType])
    }

    const gridOptions = {
        // sortOrder: { name: sort.split(':')[0], direction: sort.split(':')[1] } as any,
        textLabels: {
            body: {
                noMatch: tGeneral('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: tGeneral("next"),
                previous: tGeneral("previous"),
                rowsPerPage: tGeneral("rowsPerPage") + ":",
                displayRows: tGeneral("of"),
            }
        }
    }

    //Personalizar aparencia da grid de galpoes
    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            }
        }
    })

    
    const movementTypeListColumns = [
        {
            name: 'movementTypeId',
            options: {
                display: false,
            }
        },
        {
            name: 'tolerance',
            options: {
                display: false,
            }
        },
        {
            name: 'movementTypeDescription',
            label: tShed('movementType'),
        },
        {
            name: 'tolerance',
            label: tShed('tolerance'),
            options: {
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (!editingMovementType || 
                         editingMovementType.movementTypeId === undefined ||
                         editingMovementType.movementTypeId !== tableMeta.rowData[0])
                        return value
                    
                    return <TextField 
                            style={{width: '100px', marginLeft: 12, marginRight: 12 }}
                            label={tShed("tolerance")} 
                            name="shedMovementTypeTolerance" 
                            control={control} 
                            mask="99:99" />
                }
            }
        },
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    renderButtons(tableMeta.rowData[0], tableMeta.rowData[1])
                )
            }
        }
    ]

   
    const renderButtons = (movementTypeId: string, tolerance: string) => {

        if (!editingMovementType || 
             editingMovementType.movementTypeId  === undefined ||
             editingMovementType.movementTypeId !== movementTypeId) {
            return (
                <Box display="right">
                    <IconButton aria-label="Edit" color="primary" onClick={() => proccessEditigMovementType(movementTypeId, tolerance)}>
                        <EditIcon fontSize='small'/>                              
                    </IconButton>
                    <IconButton aria-label="Edit" color="primary" onClick={() => deleteShedMovementType(movementTypeId)}>
                        <DeleteIcon fontSize='small'/>                              
                    </IconButton>
                </Box>)
        }

        return (
            <Box display="right">
                <IconButton aria-label="Edit" color="primary" onClick={() => saveEditigMovementType(movementTypeId)}>
                    <SaveIcon fontSize='small'/>                              
                </IconButton>
                <IconButton aria-label="Edit" color="primary" onClick={() => proccessEditigMovementType()}>
                    <CancelIcon fontSize='small'/>                              
                </IconButton>
            </Box>)
    }

    const proccessEditigMovementType = (movementTypeId? : string, tolerance?: string) => {
        clearErrors('shedMovementTypeTolerance')
        setEditingMovementType({movementTypeId: movementTypeId, tolerance: tolerance})
        setValue('shedMovementTypeTolerance', tolerance)
    }

    const saveEditigMovementType = (movementTypeId : string) => {
        var shedMovementTypeListAux = shedMovementTypeList

        var data = getValues()

        var newTolerance = data.shedMovementTypeTolerance

        if (newTolerance.replace('_', '').length < 5){
            setError('shedMovementTypeTolerance', { message: tval("formatTime") });
            return
        }

        if (parseInt(newTolerance.split(':')[0]) < 0 ||
            parseInt(newTolerance.split(':')[0]) > 23 || 
            parseInt(newTolerance.split(':')[1]) < 0 ||
            parseInt(newTolerance.split(':')[1]) > 59){
            setError('shedMovementTypeTolerance', { message: tval("formatTime24h") });
            return
        }

        clearErrors('shedMovementTypeTolerance')
        
        shedMovementTypeListAux.find(f => f.movementTypeId === movementTypeId).tolerance = newTolerance
        setShedMovementTypeList(shedMovementTypeListAux)
        proccessEditigMovementType()
    }

    const deleteShedMovementType = (movementTypeId : string) => {
        setShedMovementTypeList(shedMovementTypeList.filter((element : any) => element.movementTypeId !== movementTypeId))
    }

    return (
        <Container maxWidth={false} component="main">
        {
        loading ?
        <LoadingUI />
        :
        <React.Fragment>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                <form onSubmit={handleSubmit(onSubmit)} id="form">
                <Grid container spacing={1}>

                <Grid item xs={5}>
                    <PageTitle title={`${props.shedId === 0 ? tShed("addTitle") : tShed("editTitle")}`} style={{ marginLeft: "40px" }} />
                </Grid>

                <Grid item xs={7} style={{display:'flex', justifyContent:'right'}}>
                    <Button 
                        variant="contained" 
                        className={classes.rootCancelButton} 
                        startIcon={<CancelIcon />}
                        onClick={() => props && props.clickHandlerClose ? props.clickHandlerClose() : null}>
                        {tGeneral("cancel")}
                    </Button>
                    <Button  
                        type="submit"
                        variant="contained" 
                        color="primary" 
                        startIcon={<SaveIcon />}
                        className={classes.rootButton}>
                        {tGeneral("save")}
                    </Button>
                </Grid>

                </Grid>
                    <Grid container spacing={1} style={{marginTop: 20}}>

                        <Grid container spacing={1}>

                            <Grid item xs={2}>
                                <TextField 
                                    label={tShed("code")} 
                                    name="code" 
                                    control={control} 
                                    inputProps={{maxLength: 6}} 
                                    fullWidth
                                    InputProps={{
                                        readOnly: props.shedId > 0 ? true : false ,
                                        classes: {
                                            input: props.shedId > 0 ? classes.inputBlocked : classes.rootTextBox
                                        }
                                    }}
                                    />
                            </Grid>
                            <Grid item xs={3}>
                                <Select
                                    label={tShed("type")} 
                                    name="type"
                                    onChange={onChangeSelectType}
                                    control={control} 
                                    disabled={props.shedId > 0}
                                    options={shedTypeList}
                                    style={{width: '100%'}}
                                />
                            </Grid>
                        </Grid>
                        {
                            isLoadType && (
                                <Grid container spacing={0}>
                                    <Grid item xs={4}>
                                        <Select
                                            label={tShed("companies")} 
                                            name="companies" 
                                            required={isLoadType}
                                            control={control} 
                                            multiple={true}
                                            options={companyList}
                                            setValue={setValue}
                                            style={{width: '100%'}}
                                            />
                                    </Grid>
                                </Grid>
                            )    
                        }
                        {(isPortoReal() && isLoadType) && (
                            <Grid container spacing={0}>
                                <Grid item xs={4}>
                                    <label>
                                        <input type="checkbox" {...register('generatesBtpInvoice')} />
                                        {tShed('generatesBtpInvoice')}
                                    </label>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>

                    <Grid container spacing={1} style={{marginLeft: -10, marginTop: 30}}>
                        <Grid item xs={7}>
                            <Select 
                                style={{width: '100%'}}
                                label={tShed('movementType')} 
                                name={'movementType'}
                                control={control} 
                                allowSelectValueNotFound={false}
                                inputRef={refFieldMovementType}
                                options= {movementTypeList} />
                        </Grid> 

                        <Grid item xs={2}>
                            <TextField 
                                style={{width: '100%', marginLeft: 12, marginRight: 12 }}
                                label={tShed("tolerance")} 
                                name="tolerance" 
                                control={control} 
                                onKeyDown={(e) => {if (e.key === 'Enter') handleIncludeMovementType(); }}
                                mask="99:99" />                                     
                        </Grid>

                        <Grid item xs={1}>
                            <ButtonUI
                                onClick={() => {handleIncludeMovementType(); refFieldMovementType.current?.focus()}}
                                color="primary"
                                variant="contained"
                                style={{ maxWidth: '40px', maxHeight: '38px', minWidth: '40px', minHeight: '38px', marginTop: '20px', marginLeft: '15px' }}>
                                <AddIcon />
                            </ButtonUI>
                        </Grid>
                        <Grid item xs={12} style={{marginLeft: 10}}>
                            <Typography className={classes.paper} style={{ marginLeft: 0 }} >
                                {tGeneral("totalRecords")} {shedMovementTypeList && shedMovementTypeList.length > 0 ? shedMovementTypeList.length : '0'}
                                { shedsErrorMessage.length === 0 ? <></> : <p style={{ color: 'red' }}>{shedsErrorMessage}</p>}
                            </Typography>
                                <MuiThemeProvider theme={myTheme}>
                                    <MUIDataTable
                                        title=""
                                        data={shedMovementTypeList}
                                        columns={movementTypeListColumns}
                                        options={{
                                            ...gridOptions,
                                            serverSide: false,
                                            pagination: false,
                                            sort: false,
                                            selectToolbarPlacement: "none",
                                            filter: false,
                                            search: false,
                                            download: false,
                                            print: false,
                                            viewColumns: false,
                                            selectableRows: 'none',

                                        }}
                                    />
                                </MuiThemeProvider>
                            </Grid>
                    </Grid>
                </form>

            </React.Fragment>
        }
        </Container>
    )
}
export default ShedForm;
